import { Tab, Tabs, Button, Form, FormGroup, TextInput } from "carbon-components-react"; // prettier-ignore
import React, { useState } from "react";
import BeneficiariesTab from "./BeneficiariesTab";
import DonationsTab from "./DonationsTab";
import ProcessingFeeTab from "./ProcessingFeeTab";
import TeamsTab from "./TeamsTab";

const Admin = () => {
  const [loginStatus, setLoginStatus] = useState("inactive");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (username === "adminuser" && password === "password123") {
      setLoginStatus("active");
      setUsername("");
      setPassword("");
    }
  };

  return (
    <React.Fragment>
      {loginStatus === "active" ? (
        <div className="admin-page">
          <div style={{ color: "white" }}>
            <h1>Admin Workbench</h1>
          </div>
          <div>
            <Tabs
              aria-label="listbox"
              role="navigation"
              selected={0}
              selectionMode="automatic"
              type="container"
            >
              <Tab
                href="#"
                id="beneficiaries-tab"
                label="Beneficiaries"
                role="presentation"
                selected={true}
                tabIndex={0}
              >
                <BeneficiariesTab />
              </Tab>
              <Tab
                href="#"
                id="donations-tab"
                label="Donations"
                role="presentation"
                selected={false}
                tabIndex={1}
              >
                <DonationsTab />
              </Tab>
              <Tab
                href="#"
                id="teams-tab"
                label="Teams"
                role="presentation"
                selected={false}
                tabIndex={2}
              >
                <TeamsTab />
              </Tab>
              <Tab
                href="#"
                id="processing-fee-tab"
                label="Processing Fee"
                role="presentation"
                selected={false}
                tabIndex={3}
              >
                <ProcessingFeeTab />
              </Tab>
            </Tabs>
          </div>
        </div>
      ) : (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{ backgroundColor: "#F5F5F5", padding: "30px", width: 500 }}
          >
            <h4>Login</h4>
            <Form onSubmit={handleFormSubmit}>
              <FormGroup invalid={false} legendText="" message={false}>
                <TextInput
                  id="username-login"
                  invalid={false}
                  invalidText="A valid value is required"
                  labelText="Username"
                  light={true}
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
                <TextInput.PasswordInput
                  id="password-login"
                  invalid={false}
                  invalidText="A valid value is required"
                  labelText="Password"
                  light={true}
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </FormGroup>
              <Button kind="primary" type="submit">
                Login
              </Button>
            </Form>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Admin;
